import { getDataSource } from "../../services/api";
import { handleImageError } from "../../utils/common";

const TopCandidate = ({ t, selectedParty }) => {
  const hasTopCandidate = selectedParty.topCandidateName ? true : false;
  const isWomenTopCandidate =
    selectedParty.logo === "lsap" || selectedParty.logo === "deigreng";
  return (
    <div className="flex flex-row px-0 my-5 md:w-[650px]">
      <div className="w-1/2">
        {!hasTopCandidate && (
          <img
            src={`${getDataSource()}/top-candidates/candidate-bg-logo_${
              selectedParty.logo
            }.png`}
            alt={selectedParty.partyName}
            onError={handleImageError}
            width={252}
          />
        )}
        {hasTopCandidate && (
          <div className="w-[192px] h-[216px]">
            <img
              src={`${getDataSource()}/top-candidates/${
                selectedParty.topCandidateImageUrl
              }_bg.png`}
              alt={selectedParty.partyName}
              onError={handleImageError}
            />
          </div>
        )}
      </div>
      {hasTopCandidate && (
        <div className="flex flex-col w-1/2">
          <span>
            {isWomenTopCandidate ? t("topCandidateWomen") : t("topCandidate")}:
          </span>
          <span className="text-22 font-medium">
            {selectedParty.topCandidateName}
          </span>

          <div className="w-[100px]">
            <img
              src={`${getDataSource()}/parties/${selectedParty.logo}.png`}
              alt={selectedParty.partyName}
              onError={handleImageError}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TopCandidate;
